import { Box, Drawer, Group, Text } from "@mantine/core";
import { useCallback, useEffect, useRef } from "react";
import AiAssistantIcon from "components/AiAssistantIcon/AiAssistantIcon";
import ChatComposer from "./ChatComposer";
import ChatMessageList from "./ChatMessageList";
import css from "./MicChatDrawer.module.scss";

const MicChatDrawer = ({
  opened,
  onClose,
  messages,
  isAiThinking,
  assistantProgress,
  onSendMessage,
  onSelectSource,
}) => {
  const composerRef = useRef(null);

  const focusComposer = useCallback(() => {
    window.requestAnimationFrame(() => {
      composerRef.current?.focus();
    });
  }, []);

  useEffect(() => {
    if (!opened) return undefined;

    const timeoutId = window.setTimeout(focusComposer, 120);
    return () => window.clearTimeout(timeoutId);
  }, [focusComposer, opened]);

  const handleSendMessage = (content) => {
    onSendMessage(content);
    focusComposer();
  };

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      size={560}
      title={
        <Group spacing="sm" noWrap className={css.drawerTitle}>
          <AiAssistantIcon />
          <Text weight={700} size="lg" color="#373B54">
            GainTime Assistant
          </Text>
        </Group>
      }
      overlayOpacity={0.18}
      overlayBlur={2}
      padding={0}
      styles={{
        header: {
          padding: "18px 22px",
          borderBottom: "1px solid #edf0f5",
          marginBottom: 0,
        },
        body: { height: "calc(100% - 73px)", padding: 0 },
      }}
    >
      <Box className={css.drawerRoot}>
        <ChatMessageList
          messages={messages}
          isAiThinking={isAiThinking}
          assistantProgress={assistantProgress}
          onSelectSource={onSelectSource}
        />
        <div className={css.composerWrap}>
          <ChatComposer
            ref={composerRef}
            disabled={isAiThinking}
            onSendMessage={handleSendMessage}
          />
        </div>
      </Box>
    </Drawer>
  );
};

export default MicChatDrawer;
